import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/api-keys')({
  component: lazyRouteComponent(() => import('./-api-keys.lazy'), 'default'),
});
